import React from "react";

import { Box, Card, CardActionArea, CardActions, CardContent, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import { Operator } from "modules/customer/tools/product/operator";
import numberFormatter from "utils/numberFormatter";
import BarChart from "pages/customer/tools/product/filters/BarChart";

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main,
        borderColor: (props: any) => props["data-selected"] ? theme.palette.common.white : "transparent",
        borderStyle: "solid",
        borderWidth: "1px",
        height: "100%"
    }
}))(Card);

const StyledCardActions = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.light
    }
}))(CardActions);

const StyledCardActionArea = withStyles(theme => ({
    root: {
        height: "100%",
        minWidth: "100%"
    }
}))(CardActionArea);

const StyledCardContent = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main
    }
}))(CardContent);

interface OperatorCardProps {
    operator: Operator,
    selected: boolean,
    onSelect: (partner: Operator) => void,
    onDeselect: (partner: Operator) => void
}

const OperatorCard: React.FC<OperatorCardProps> = (props) => {
    const { operator, selected, onSelect, onDeselect } = props;
    const theme = useTheme();
    const showLabel = true;

    const handleClick = () => {
        if (selected) {
            onDeselect(operator);
        } else {
            onSelect(operator);
        }
    };

    return (
        <StyledCard elevation={0} data-selected={selected}>
            <StyledCardActionArea onClick={handleClick} disableRipple disableTouchRipple>
                <StyledCardActions style={{ height: theme.spacing(12) }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {operator.name}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                Headroom
                            </Typography>
                            <Typography
                                variant="h5"
                                component="div"
                                align="center"
                            >
                                {numberFormatter.toGBP(operator.sales.salesHeadroom, 1)}
                            </Typography>
                        </Grid>
                    </Grid>
                </StyledCardActions>
                <StyledCardContent>
                    <BarChart sales={operator.sales} />
                </StyledCardContent>
                {showLabel && <StyledCardActions>
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                        <Typography
                            variant="h6"
                            component="span"
                            align="center"
                            display="inline"
                            style={{ color: theme.palette.text.primary }}
                        >
                            {operator.status}
                        </Typography>
                    </Box>
                </StyledCardActions>}
            </StyledCardActionArea>
        </StyledCard>
    );
};

export default OperatorCard;
